<template>
    <div class="hotRecommend" @click="$emit('closeHotPopup')">
        <div class="content">
        <div class="title">热门课程</div>
            <div class="contentList">
                <RecommendCourse />
            </div>
        </div>
    </div>
</template>
<script>
import RecommendCourse from '../../live/components/recommendCourse.vue';

export default {
  name: 'hotRecommend',
  data() {
    return {

    };
  },
  components: {
    RecommendCourse,
  },
};
</script>
<style lang="scss" scoped>
.hotRecommend {
    position: absolute;
    top:0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 11;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.3);
    transform: translateZ(100px);
    .content {
      position: absolute;
      top: 0;
      right: 0;
      width: 50%;
      height: 100%;
      overflow: auto;
      background: rgba(0,0,0,0.3);
      .title {
        margin-top: 40px;
        padding-left: 40px;
        color: #fff;
        font-size: 40px;
      }
    }
}
</style>
